import React from "react";
import { Box, Divider, Typography } from "@mui/material";

const Footer = () => {
  const appTitle =
    import.meta.env.VITE_APP_SYS_TITLE ||
    import.meta.env.VITE_APP_ENTER_TITLE ||
    "";
  const appVersion = import.meta.env.VITE_APP_VERSION;
  const ano = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        pt: 2,
        pb: 3,
        px: { xs: 2, md: 3 },
        textAlign: "center",
        color: "text.secondary",
      }}
    >
      <Divider sx={{ mb: 1.5, opacity: 0.6 }} />
      <Typography
        variant="caption"
        sx={{ letterSpacing: "0.04em", textTransform: "uppercase" }}
      >
        {appTitle}
        {appVersion ? ` ${appVersion}` : ""} • Copyright © {ano} CHAG. Todos os
        direitos reservados.
      </Typography>
    </Box>
  );
};

export default Footer;
